import type { CartItem } from "@repo/core/cart";

import { env } from "@/env";

export function isCartProductItem(item: CartItem) {
  return item.partNo !== env.NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO;
}

export function getCartProductItems(items: CartItem[] = []) {
  return items.filter(isCartProductItem);
}

export function getCartQuantity(items: CartItem[] = []) {
  return getCartProductItems(items).reduce(
    (total, item) => total + item.quantity,
    0,
  );
}
